import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fractions',
  templateUrl: './fractions.component.html',
  styleUrls: ['./fractions.component.css']
})
export class FractionsComponent implements OnInit {
  title = 'Øv dig i at regne med brøker';
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/fractions/fractions.component.ts